<template>
    <div>
        <headerM :year="year" @yearNum="yearNum"/>
        <div class="content">
            <div class="month" :class="{isNowMonth:isNowMonth(i.value),isChoice:isChoice(i.value)}" v-for="i in months" :key="i.txt" 
            @click="choiceMonth(i.value)"
            >{{i.txt}}</div>
        </div>
    </div>
</template>

<script>
import headerM from './headerM'
import dayjs from "dayjs";
import * as utils from "../utils";
    export default {
        name:'month',
        components:{
            headerM
        },
        data() {
            return {
                year: dayjs().get("year"),
                month: dayjs().get("month"),
                months:[
                    {
                        txt:'一月',
                        value:0
                    },
                    {
                        txt:'二月',
                        value:1
                    },
                    {
                        txt:'三月',
                        value:2
                    },
                    {
                        txt:'四月',
                        value:3
                    },
                    {
                        txt:'五月',
                        value:4
                    },
                    {
                        txt:'六月',
                        value:5
                    },
                    {
                        txt:'七月',
                        value:6
                    },
                    {
                        txt:'八月',
                        value:7
                    },
                    {
                        txt:'九月',
                        value:8
                    },
                    {
                        txt:'十月',
                        value:9
                    },
                    {
                        txt:'十一月',
                        value:10
                    },
                    {
                        txt:'十二月',
                        value:11
                    },
                ],
                choiceM:''
            }
        },
        methods: {
            yearNum(v) {
            // console.log(v);
            this.year = v;
            // this.getShowDays();
        },
        isNowMonth(m){
            if (dayjs().get("year")==this.year) {
                return m == this.month
            }
        },
        isChoice(m){
            if (`${this.year}-${m}`==this.choiceM) return true
        },
        choiceMonth(v){
            this.choiceM = `${this.year}-${v}`
            // console.log(this.choiceM);
            let obj = {}
            obj.startDate = `${this.year}-${utils.padZero(v+1)}-01`
            obj.endDate = utils.getMonthFinalDay(this.year,v+1)
            obj.index=2
            this.$emit('month',obj)
        }
        },
    }
</script>

<style lang="scss" scoped>
.content{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    flex-wrap: wrap;
    margin-top: 10px;
    cursor: pointer;
    .month{
        font-size: 14px;
        width: 23%;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        margin: 15px 3px;
        &:hover{
            color: #409eff;
        }
    }
    .isNowMonth{
        color: #409eff;
        font-weight: 700;
    }
    .isChoice{
        background-color: #409eff;
        color: #fff;
        &:hover{
            color: #fff;
        }
    }
}

</style>